import { gql } from 'apollo-angular';

const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    email
    nome
    handle
    avatarUrl
    saldoPalpitas
    acceptedTosAt
    acceptedTosVersion
    bloqueadoEm
    bloqueadoMotivo
    admin
    lastDailyAt
    streakDays
    criadoEm
    atualizadoEm
  }
`;

export const REGISTRAR_MUTATION = gql`
  mutation Registrar($input: RegistrarInput!) {
    registrar(input: $input) {
      sessionToken
      user {
        ...UserFields
      }
    }
  }
  ${USER_FIELDS}
`;

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      sessionToken
      user {
        ...UserFields
      }
    }
  }
  ${USER_FIELDS}
`;

export const ME_QUERY = gql`
  query Me {
    me {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const ACEITAR_TOS_MUTATION = gql`
  mutation AceitarTos($versao: String!) {
    aceitarTos(versao: $versao) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;
